import { render, staticRenderFns } from "./HomeWishlistEN.vue?vue&type=template&id=4504c22a&scoped=true"
import script from "./HomeWishlistEN.vue?vue&type=script&lang=js"
export * from "./HomeWishlistEN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4504c22a",
  null
  
)

export default component.exports